export default function setUnsavedChanges(state, action) {
  state.hasUnsaveChanges = action.payload;
}
